import { render, staticRenderFns } from "./JoinUsSocial.vue?vue&type=template&id=38279ea0"
import script from "./JoinUsSocial.vue?vue&type=script&lang=js"
export * from "./JoinUsSocial.vue?vue&type=script&lang=js"
import style0 from "./JoinUsSocial.vue?vue&type=style&index=0&id=38279ea0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports